import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Field, Formik } from 'formik';
import { KeyboardDatePicker } from 'formik-material-ui-pickers';
import { useAuthContext } from '../../../contexts/Auth';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button/Button';

const useStyles = makeStyles((theme: any) => ({
  field: {
    display: 'none',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
  },
  oldDate: {
    maxWidth: theme.spacing(21),
    minWidth: theme.spacing(17),
    justifyContent: 'center',
    height: theme.spacing(6),
    border: `1px solid ${theme.palette.brand.blueSky}`,
    borderRadius: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  newDate: {
    boxShadow: `1px 2px 8px 1px rgba(9, 180, 214, 0.4)`,
  },
  img: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4),
  },
  infoImg: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  date: {
    fontWeight: 'bold',
  },
  InfoNote: {
    border: `1px solid ${theme.palette.brand.greyWhite}`,
    borderLeft: `8px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(6),
    display: 'flex',
  },
  infoText: {
    color: theme.palette.primary.main,
    alignSelf: 'center',
  },
}));

export default function DatePicker({ startDate, date, setDate }) {
  const classes = useStyles();
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const { isAdminUser } = useAuthContext();

  const checkDateForShow = (date) => {
    if (isAdminUser) return false;
    return date.getDay() !== 4;
  };

  const content = (
    <Formik
      initialValues={{ date: startDate }}
      onSubmit={async (e) => {
        if (!moment(e).isValid()) return;
      }}
      component={(values) => {
        return (
          <>
            <Button
              className={classes.oldDate + ' ' + classes.newDate}
              onClick={() => setOpenDatePicker(!openDatePicker)}
            >
              <Typography variant="body1" className={classes.date}>
                {date ? moment(date).format('MMM/DD/YYYY') : 'New Date'}
              </Typography>
            </Button>
            <Field
              component={KeyboardDatePicker}
              disableToolbar
              open={openDatePicker}
              disablePast
              shouldDisableDate={checkDateForShow}
              name={'date'}
              className={classes.field}
              onClose={() => setOpenDatePicker(false)}
              onChange={(event) => {
                if (!moment(event).isValid()) return;
                setOpenDatePicker(false);
                setDate(event);
                values.setValues({ date: event });
              }}
            />
          </>
        );
      }}
    />
  );

  return (
    <>
      <div className={classes.container}>
        <div className={classes.oldDate}>
          <Typography variant="body1" className={classes.date}>
            {moment(startDate).format('MMM/DD/YYYY')}
          </Typography>
        </div>
        <img
          src={'./general/rightArrow.svg'}
          className={classes.img}
          alt="right arrow"
        />
        {content}
      </div>
      <div className={classes.InfoNote}>
        <img
          src={'./icons/info.svg'}
          className={classes.infoImg}
          alt="right arrow"
        />
        <Typography variant="subtitle1" className={classes.infoText}>
          A specific remittance can only be requested to be moved one time.
        </Typography>
      </div>
    </>
  );
}
